<div class="home-folders-accordion-container">
  <!-- Loading State -->
  <div *ngIf="loading"
       class="loading-container">
    <mat-progress-spinner color="warn"
                          [diameter]="40"
                          [strokeWidth]="4"></mat-progress-spinner>
    <p *ngIf="loadingMessage"
       class="loading-message">
      {{loadingMessage}}
    </p>
  </div>

  <!-- Expandable Folders List -->
  <div *ngIf="!loading && folders.length > 0"
       class="folders-list">
    <ng-container *ngFor="let folder of folders; let i = index">
      <!-- Render folder and its children recursively -->
      <ng-container *ngTemplateOutlet="folderTemplate; context: { $implicit: folder, level: 0 }"></ng-container>
    </ng-container>
  </div>

  <!-- Folder Template for Recursive Rendering -->
  <ng-template #folderTemplate
               let-folder
               let-level="level">
    <div #folderItem
         class="folder-item"
         [ngClass]="{ 
           'expanded': isExpanded(folder),
           'index-folder': folder.name === 'INDEX',
           'subfolder': level > 0
         }"
         [style.margin-left]="getFolderIndent(folder)">

      <!-- Folder Header -->
      <div class="folder-header"
           [ngClass]="{ 'expanded': isExpanded(folder) }"
           (click)="onFolderClick(folder, $event)"
           (mousedown)="onFolderMouseDown(folder, $event)">
        <div class="folder-info">
          <div class="folder-title-group">
            <mat-icon class="folder-icon"
                      [ngStyle]="{ color: getFolderColor(folder) }">
              {{ getFolderIcon(folder) }}
            </mat-icon>
            <span class="folder-name">
              {{getFolderDisplayName(folder)}}
            </span>
            <span *ngIf="folder.count"
                  class="folder-count">
              ({{ folder.count }})
            </span>
          </div>
          <mat-icon *ngIf="folder.hasNotifications"
                    class="blinking-bell notification-icon">
            fiber_manual_record
          </mat-icon>
        </div>

        <!-- Action Buttons -->
        <div class="folder-actions">
          <!-- Clear Results Button for Search Results -->
          <button *ngIf="folder.type === 'search-results'"
                  class="clear-results-button"
                  mat-icon-button
                  matTooltip="Clear search results"
                  (click)="onClearSearchResults()">
            <mat-icon>
              clear
            </mat-icon>
          </button>

          <!-- Refresh Button -->
          <button *ngIf="isExpanded(folder) && folder.type !== 'search-results'"

                  mat-icon-button
                  matTooltip="Refresh folder contents"

                  [disabled]="isRefreshing(folder)"
                  (click)="onRefreshFolder(folder, $event)">
            <mat-icon *ngIf="!isRefreshing(folder)">
              refresh
            </mat-icon>
            <mat-progress-spinner *ngIf="isRefreshing(folder)"
                                  [diameter]="20"
                                  [strokeWidth]="2">
            </mat-progress-spinner>
          </button>



          <!-- Delete Folder Button -->
          <button *ngIf="!folder.predefined && permissions.deletefiles"
                  class="delete-folder-button"
                  mat-button
                  matTooltip="Delete folder"
                  (click)="onDeleteFolder(folder, $event)">
            <mat-icon>
              delete
            </mat-icon>
            Delete Folder
          </button>

          <!-- Expansion Icon -->
          <mat-icon class="expansion-icon"
                    [ngClass]="{ 'expanded': isExpanded(folder) }">
            expand_more
          </mat-icon>
        </div>
      </div>

      <!-- Folder Content (Files Table) -->
      <div *ngIf="isExpanded(folder)"
           class="folder-content">

        <!-- Loading State for Folder -->
        <div *ngIf="folder.loading"
             class="folder-loading">
          <mat-progress-spinner color="warn"
                                [diameter]="20"
                                [strokeWidth]="3"></mat-progress-spinner>
          <span>
            Loading files...
          </span>
        </div>

        <!-- Files Table -->
        <div *ngIf="!folder.loading && folder.files && folder.files.length > 0"
             class="files-table-container">

          <div class="files-table">
            <table class="accordion-table">
              <!-- Table Header -->
              <thead>
                <tr>
                  <th class="file-name-column">
                    File Name
                  </th>
                  <th class="file-content-column"
                      style="display: none;">
                    File Content
                  </th>
                  <th class="uploaded-date-column">
                    Date Uploaded
                  </th>
                  <th class="date-of-file-column">
                    Date of File
                  </th>
                  <th class="file-folder-name-column">
                    File Folder Name
                  </th>
                  <th class="file-actions-column">
                    File Actions
                  </th>
                </tr>
              </thead>

              <!-- Table Body -->
              <tbody>
                <!-- Subfolders as file-like items -->
                <ng-container *ngFor="let subfolder of getChildren(folder); trackBy: trackByFolderId">
                  <!-- Subfolder Row -->
                  <tr class="file-row subfolder-row"
                      [ngClass]="{ 'selected': isSubfolderExpanded(subfolder) }">

                    <!-- Subfolder Name Column -->
                    <td class="file-name-column">
                      <div class="file-name-content">
                        <div class="subfolder-item"
                             (click)="onSubfolderClick(subfolder, $event)">
                          <button class="subfolder-expand-button"
                                  mat-icon-button
                                  [matTooltip]="isSubfolderExpanded(subfolder) ? 'Collapse subfolder' : 'Expand subfolder'"
                                  (click)="toggleSubfolderExpansion(subfolder, $event)">
                            <mat-icon class="subfolder-expand-icon"
                                      [ngClass]="{ 'expanded': isSubfolderExpanded(subfolder) }">
                              expand_more
                            </mat-icon>
                          </button>
                          <div class="subfolder-content">
                            <mat-icon class="subfolder-icon">
                              folder
                            </mat-icon>
                            <span class="subfolder-name">
                              {{ subfolder.name }}
                            </span>
                            <span *ngIf="subfolder.count"
                                  class="subfolder-count">
                              ({{ subfolder.count }})
                            </span>
                            <mat-icon *ngIf="subfolder.hasNotifications"
                                      class="blinking-bell notification-icon">
                              fiber_manual_record
                            </mat-icon>
                          </div>
                        </div>
                      </div>
                    </td>

                    <!-- Empty columns for subfolder row -->
                    <td class="file-content-column"
                        style="display: none;">
                      -
                    </td>
                    <td class="uploaded-date-column">
                      -
                    </td>
                    <td class="date-of-file-column">
                      -
                    </td>
                    <td class="file-folder-name-column">
                      -
                    </td>
                    <td class="file-actions-column">
                      <!-- Subfolder actions -->
                      <div class="subfolder-actions">
                        <button *ngIf="permissions.deletefiles"
                                class="action-button delete-subfolder-btn"
                                mat-icon-button
                                matTooltip="Delete subfolder"
                                (click)="onDeleteFolder(subfolder, $event); $event.stopPropagation()">
                          <mat-icon>
                            delete
                          </mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>

                  <!-- Subfolder Files (nested within the same table) -->
                  <ng-container *ngIf="isSubfolderExpanded(subfolder)">
                    <!-- Loading State for Subfolder -->
                    <tr *ngIf="subfolder.loading"
                        class="subfolder-loading-row">
                      <td class="subfolder-loading-cell"
                          colspan="6">
                        <div class="subfolder-loading">
                          <mat-progress-spinner color="warn"
                                                [diameter]="20"
                                                [strokeWidth]="3"></mat-progress-spinner>
                          <span>
                            Loading {{ subfolder.name }} files...
                          </span>
                        </div>
                      </td>
                    </tr>

                    <!-- Subfolder Files -->
                    <tr *ngFor="let file of getPaginatedFiles(subfolder); trackBy: trackByFileId"
                        class="file-row subfolder-file-row"
                        [ngClass]="{ 'selected': isFileSelected(subfolder, file) }">

                      <!-- File Name Column -->
                      <td class="file-name-column">
                        <div class="file-name-content subfolder-file-content">
                          <ng-container *ngIf="isDicomFile(file); else regularFile">
                            <span class="imaging-study-label"
                                  (click)="onFileClick(file, $event)">
                              <mat-icon class="imaging-study-icon">
                                visibility
                              </mat-icon>
                              Imaging Study
                            </span>
                          </ng-container>
                          <ng-template #regularFile>
                            <button *ngIf="file.viewerurl && !isInactiveStore(file)"
                                    class="view-link"
                                    matTooltip="Click here to browse the study in the DICOM viewer."
                                    (click)="onStudyClick(file, $event)">
                              <mat-icon aria-hidden="false"
                                        aria-label="preview icon">
                                preview
                              </mat-icon>
                              {{ file.fileName }}
                            </button>
                            <div *ngIf="!file.viewerurl || isInactiveStore(file)"
                                 class="regular-file"
                                 (click)="onFileClick(file, $event)">
                              <mat-icon class="file-icon">
                                {{ file.type === 'folder' ? 'folder' : 'description' }}
                              </mat-icon>
                              <span class="file-name">
                                {{file.fileName}}
                              </span>
                            </div>
                          </ng-template>
                          <mat-icon *ngIf="file.hasNotifications"
                                    class="blinking-bell notification-icon">
                            fiber_manual_record
                          </mat-icon>
                          <mat-icon *ngIf="file.hasCommentAttachments"
                                    class="comment-attachment-icon"
                                    matTooltip="This file has comment attachments."
                                    (click)="onAddCommentOrAttachment(file, $event)">
                            comment
                          </mat-icon>
                          <mat-icon *ngIf="file.sharedUsers && file.sharedUsers.length > 0"
                                    class="shared-icon"
                                    matTooltip="This file is shared."
                                    (click)="onSharedIconClick(file, $event)">
                            people
                          </mat-icon>
                        </div>
                      </td>

                      <!-- File Content Column -->
                      <td class="file-content-column"
                          style="display: none;">
                        {{file.fileDesc || ''}}
                      </td>

                      <!-- Date Uploaded Column -->
                      <td class="uploaded-date-column"
                          matTooltipPosition="above"
                          [matTooltip]="file.uploadedDate || 'No date available'">
                        {{ formatDate(file.uploadedDate) }}
                      </td>

                      <!-- Date of File Column -->
                      <td class="date-of-file-column"
                          matTooltipPosition="above"
                          [matTooltip]="file.fdate ? (file.ftime ? file.fdate + ' ' + file.ftime : file.fdate) : 'No date available'">
                        {{ formatFileDateTime(file.fdate, file.ftime) }}
                      </td>

                      <!-- File Folder Name Column -->
                      <td class="file-folder-name-column">
                        <a mat-flat-button
                           matTooltip="{{ file.parentFolderName || file.parentFolder || '-' }}"
                           [ngClass]="['folder-button', 'short']"
                           [ngStyle]="file.style"
                           (click)="onFolderNameClick(file, $event)">
                          <mat-icon aria-hidden="false"
                                    aria-label="Folder icon"
                                    [ngStyle]="{ color: file.color || '#757575' }">
                            folder
                          </mat-icon>
                          {{ file.parentFolderName || file.parentFolder || '-' }}
                        </a>
                      </td>

                      <!-- File Actions Column -->
                      <td class="file-actions-column">
                        <button *ngIf="permissions.editfiles && file.folderId !== 'all' && file.predefined !== true"
                                mat-icon-button
                                matTooltip="Click to edit this file."
                                (click)="onEditFile(file, $event); $event.stopPropagation()">
                          <mat-icon>
                            create
                          </mat-icon>
                        </button>
                        <button *ngIf="permissions.deletefiles && file.type !== 'folder'"
                                mat-icon-button
                                matTooltip="Click here to delete this from the files you have uploaded."
                                (click)="onDeleteFile(file, $event); $event.stopPropagation()">
                          <mat-icon>
                            delete
                          </mat-icon>
                        </button>
                        <button *ngIf="file.type !== 'folder'"
                                mat-icon-button
                                matTooltip="Click to copy this file to another folder."
                                (click)="onCopyFile(file, $event); $event.stopPropagation()">
                          <mat-icon>
                            content_copy
                          </mat-icon>
                        </button>
                        <button *ngIf="isDicomFile(file)"
                                mat-icon-button
                                matTooltip="Click to generate disc for this DICOM study."
                                (click)="onGenerateDisc(file, $event); $event.stopPropagation()">
                          <mat-icon>
                            folder_zip
                          </mat-icon>
                        </button>
                        <button *ngIf="file.type !== 'folder'"
                                mat-icon-button
                                matTooltip="Click to add comment or attachment to this file."
                                (click)="onAddCommentOrAttachment(file, $event); $event.stopPropagation()">
                          <mat-icon>
                            comment
                          </mat-icon>
                        </button>
                      </td>
                    </tr>

                    <!-- Empty state when subfolder is expanded but has no files -->
                    <tr *ngIf="!subfolder.loading && subfolder.files && subfolder.files.length === 0"
                        class="empty-subfolder-row">
                      <td class="empty-subfolder-cell"
                          colspan="6">
                        <div class="empty-subfolder-content">
                          <p class="empty-subfolder-message">
                            No files listed in {{ subfolder.name }}
                          </p>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>

                <!-- Regular files -->
                <tr *ngFor="let file of getPaginatedFiles(folder); trackBy: trackByFileId"
                    class="file-row"
                    [ngClass]="{ 'selected': isFileSelected(folder, file) }">

                  <!-- File Name Column -->
                  <td class="file-name-column">
                    <div class="file-name-content">
                      <!-- DICOMDIR/Imaging Study with special appearance -->
                      <ng-container *ngIf="isDicomFile(file); else regularFile">
                        <span class="imaging-study-label"
                              (click)="onFileClick(file, $event)">
                          <mat-icon class="imaging-study-icon">
                            visibility
                          </mat-icon>
                          Imaging Study
                        </span>
                      </ng-container>
                      <ng-template #regularFile>
                        <button *ngIf="file.viewerurl && !isInactiveStore(file)"
                                class="view-link"
                                matTooltip="Click here to browse the study in the DICOM viewer."
                                (click)="onStudyClick(file, $event)">
                          <mat-icon aria-hidden="false"
                                    aria-label="preview icon">
                            preview
                          </mat-icon>
                          {{ file.fileName }}
                        </button>
                        <div *ngIf="!file.viewerurl || isInactiveStore(file)"
                             class="regular-file"
                             (click)="onFileClick(file, $event)">
                          <mat-icon class="file-icon">
                            {{ file.type === 'folder' ? 'folder' : 'description' }}
                          </mat-icon>
                          <span class="file-name">
                            {{ file.fileName }}
                          </span>
                        </div>
                      </ng-template>
                      <mat-icon *ngIf="file.hasNotifications"
                                class="blinking-bell notification-icon">
                        fiber_manual_record
                      </mat-icon>
                      <mat-icon *ngIf="file.hasCommentAttachments"
                                class="comment-attachment-icon"
                                matTooltip="This file has comment attachments."
                                (click)="onAddCommentOrAttachment(file, $event)">
                        comment
                      </mat-icon>
                      <mat-icon *ngIf="file.sharedUsers && file.sharedUsers.length > 0"
                                class="shared-icon"
                                matTooltip="This file is shared."
                                (click)="onSharedIconClick(file, $event)">
                        people
                      </mat-icon>
                    </div>
                  </td>

                  <!-- File Content Column -->
                  <td class="file-content-column"
                      style="display: none;">
                    {{ file.fileDesc || '' }}
                  </td>


                  <!-- Date Uploaded Column -->
                  <td class="uploaded-date-column"
                      matTooltipPosition="above"
                      [matTooltip]="file.uploadedDate || 'No date available'">
                    {{ formatDate(file.uploadedDate) }}
                  </td>

                  <!-- Date of File Column -->
                  <td class="date-of-file-column"
                      matTooltipPosition="above"
                      [matTooltip]="file.fdate ? (file.ftime ? file.fdate + ' ' + file.ftime : file.fdate) : 'No date available'">
                    {{ formatFileDateTime(file.fdate, file.ftime) }}
                  </td>

                  <!-- File Folder Name Column -->
                  <td class="file-folder-name-column">
                    <a mat-flat-button
                       matTooltip="{{ file.parentFolderName || file.parentFolder || '-' }}"
                       [ngClass]="['folder-button', 'short']"
                       [ngStyle]="file.style"
                       (click)="onFolderNameClick(file, $event)">
                      <mat-icon aria-hidden="false"
                                aria-label="Folder icon"
                                [ngStyle]="{ color: file.color || '#757575' }">
                        folder
                      </mat-icon>
                      {{ file.parentFolderName || file.parentFolder || '-' }}
                    </a>
                  </td>

                  <!-- File Actions Column -->
                  <td class="file-actions-column">
                    <button *ngIf="permissions.editfiles && 
                                  file.folderId !== 'all' && 
                                  file.predefined !== true"
                            mat-icon-button
                            matTooltip="Click to edit this file."
                            (click)="onEditFile(file, $event); $event.stopPropagation()">
                      <mat-icon>
                        create
                      </mat-icon>
                    </button>
                    <button *ngIf="file.permission_delete && file.type !== 'folder'"
                            mat-icon-button
                            matTooltip="Click here to delete this from the files you have uploaded."
                            (click)="onDeleteFile(file, $event); $event.stopPropagation()">
                      <mat-icon>
                        delete
                      </mat-icon>
                    </button>
                    <button *ngIf="file.type !== 'folder'"
                            mat-icon-button
                            matTooltip="Click to copy this file to another folder."
                            (click)="onCopyFile(file, $event); $event.stopPropagation()">
                      <mat-icon>
                        content_copy
                      </mat-icon>
                    </button>
                    <button *ngIf="isDicomFile(file)"
                            mat-icon-button
                            matTooltip="Click to generate disc for this DICOM study."
                            (click)="onGenerateDisc(file, $event); $event.stopPropagation()">
                      <mat-icon>
                        folder_zip
                      </mat-icon>
                    </button>
                    <button *ngIf="file.type !== 'folder'"
                            mat-icon-button
                            matTooltip="Click to add comment or attachment to this file."
                            (click)="onAddCommentOrAttachment(file, $event); $event.stopPropagation()">
                      <mat-icon>
                        comment
                      </mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Pagination Controls -->
            <div *ngIf="getPaginationState(folder.id).totalPages > 1"
                 class="pagination-controls">
              <div class="page-size-controls">
                <label for="pageSize-{{folder.id}}">
                  Items per page:
                </label>
                <select #pageSizeSelect
                        id="pageSize-{{folder.id}}"
                        [value]="getPaginationState(folder.id).pageSize"
                        (change)="onPageSizeChange(folder.id, +pageSizeSelect.value)">
                  <option *ngFor="let size of getPageSizeOptions()"
                          [value]="size">
                    {{ size }}
                  </option>
                </select>
              </div>

              <!-- Pagination Navigation -->
              <div class="pagination-navigation">
                <button class="pagination-btn"
                        matTooltip="First page"
                        [disabled]="getPaginationState(folder.id).currentPage === 1"
                        (click)="onPageChange(folder.id, 1)">
                  <mat-icon>
                    first_page
                  </mat-icon>
                </button>

                <button class="pagination-btn"
                        matTooltip="Previous page"
                        [disabled]="getPaginationState(folder.id).currentPage === 1"
                        (click)="onPageChange(folder.id, getPaginationState(folder.id).currentPage - 1)">
                  <mat-icon>
                    chevron_left
                  </mat-icon>
                </button>

                <span class="page-info">
                  Page {{ getPaginationState(folder.id).currentPage }} of {{ getPaginationState(folder.id).totalPages }}
                </span>

                <button class="pagination-btn"
                        matTooltip="Next page"
                        [disabled]="getPaginationState(folder.id).currentPage === getPaginationState(folder.id).totalPages"
                        (click)="onPageChange(folder.id, getPaginationState(folder.id).currentPage + 1)">
                  <mat-icon>
                    chevron_right
                  </mat-icon>
                </button>

                <button class="pagination-btn"
                        matTooltip="Last page"
                        [disabled]="getPaginationState(folder.id).currentPage === getPaginationState(folder.id).totalPages"
                        (click)="onPageChange(folder.id, getPaginationState(folder.id).totalPages)">
                  <mat-icon>
                    last_page
                  </mat-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- Empty state when not loading and no files loaded yet -->
          <div *ngIf="!folder.loading && !folder.files"
               class="files-list">
            <div class="no-files">
              <p>
                Click to load folder contents
              </p>
            </div>
          </div>
        </div>


        <!-- Empty state when folder is expanded but has no files -->
        <div *ngIf="!folder.loading && folder.files && folder.files.length === 0"
             class="empty-folder-container">
          <div class="empty-folder-content">
            <!-- Special message for search results -->
            <div *ngIf="folder.type === 'search-results'"
                 class="no-search-results">
              <mat-icon class="no-results-icon">
                search_off
              </mat-icon>
              <p class="no-results-title">
                No search results found
              </p>
              <p class="no-results-description">
                No files match your search criteria "{{ searchQuery }}"
              </p>
              <p class="no-results-hint">
                Try adjusting your search terms or browse through the folders
              </p>
            </div>
            <!-- Regular empty folder message -->
            <p *ngIf="folder.type !== 'search-results'"
               class="empty-folder-message">
              No files listed in {{ getFolderDisplayName(folder) }}
            </p>
          </div>
        </div>
      </div>

      <!-- Children folders are now handled as file-like items in the table above -->
    </div>
  </ng-template>

  <!-- No Folders Message -->
  <div *ngIf="!loading && folders.length === 0"
       class="no-folders">
    <div class="no-folders-content">
      <mat-icon class="no-folders-icon">
        folder_open
      </mat-icon>
      <h3>
        No folders available
      </h3>
      <p>
        Create your first folder to get started
      </p>
      <button *ngIf="permissions.createfolder"
              color="warn"
              mat-flat-button
              (click)="onCreateFolder()">
        <mat-icon>
          create_new_folder
        </mat-icon>
        Create First Folder
      </button>
    </div>
  </div>
</div>
